export const speakText = (text: string) => {
	// @ts-ignore
	const voice = window.responsiveVoice;
	if (voice.isPlaying()) {
		voice.cancel();
	} else {
		voice.speak(text, 'Polish Female');
	}
};
